import { Team } from '../../models';
import CacheableJson from '../CacheableJson';

/**
 * @desc LeagueTeams
 * This Collection using for league teams
 */
export default class LeagueTeams extends CacheableJson {
	get model() {
		return Team;
	}

	get default_offset() {
		return 20;
	}

	setShowMyUrl() {
		this.url = 'leagues_classic/show_teams';
		return this;
	}

	/**
	 * Method get teams joined to current league
	 * @param {object} data
	 * @returns {Promise.<Object>|*}
	 */
	show_my(data = {}) {
		return this.setShowMyUrl().fetchData(data)
	}

	setLeagueLadderUrl() {
		this.url = 'leagues_classic/ladder';
		return this;
	}

	setLeagueLadderOnlyUrl() {
		this.url = 'leagues_classic/ladder_only';
		return this;
	}

	showLeagueLadder(data = {}) {
		return this.setLeagueLadderUrl().fetchData(data);
	}

	showLeagueOnlyLadder(data = {}) {
		return this.setLeagueLadderOnlyUrl().fetchData(data);
	}

	fetchData(data) {
		return this.fetch({ data }).then(response => {
			this.count_teams += response.result.length;
			this.trigger('get:response:league:teams:count', this.count_teams);
		});
	}

	setRemoveTeamUrl() {
		this.url = 'leagues_classic/remove_team';
		return this;
	}

	removeTeam(data = {}) {
		return this.setRemoveTeamUrl().fetch({
			data
		}).then(response => {
			if (response.errors.length) {
				this.trigger('remove:team:error', response.errors);
			}
			else {
				this.trigger('remove:team:success');
			}
		});
	}

}